module.exports = __webpack_public_path__ + "static/media/mauricio.c6a5bcd5.gif";